import { gql } from "@apollo/client";
import { graph, GraphResponse } from "config/axios-context";
import { SaveSeasonMutationMutation, SeasonItemQuery, SeasonItemQueryVariables, SeasonListInfoQuery, SeasonListInfoQueryVariables } from "./graphql"

export type SeasonType = {
    id: number,
    name: string,
    active: boolean
}

export function getSeasonType(request:  GraphResponse<SaveSeasonMutationMutation>):  SeasonType | undefined {
    if(!request?.data?.season) return undefined;

    return {
        id: request.data.season.id,
        name: request.data.season.name,
        active: request.data.season.active
    }
}

// #region graph
const seasonQuery = gql`
query seasonItem($id:Int) {
    season(where: {id: {eq: $id}}) {
      name,
      id,
      active
    }
  }
`;

export const getSeasonData = async (id: number | string) => {
    const seasonId = Number(id);
    if(!seasonId) {
        throw Error( "input-not-valid");
    }

    try {
        const response = await graph<SeasonItemQuery, SeasonItemQueryVariables>({
            query: seasonQuery,
            variables: {
                id: seasonId
            }
        });

        return {
            season: seasonQueryResponseToSeasonType(response),
            response
        }
    } catch (error) {
        
    }
}

export const seasonQueryResponseToSeasonType = (response: GraphResponse<SeasonItemQuery>) => {
    if(response.data?.season) {
        return {
            id: response.data.season.id,
            active : response.data.season.active,
            name: response.data.season.name
        }
    }

    return undefined;
}

const seasonListInfoQuery = gql`
query seasonListInfo($where: SeasonFilterInput, $take: Int, $skip: Int, $order: [SeasonSortInput!]) {
    seasons {
      items(order: $order, skip:$skip, take:$take, where:$where) {
        id,
        name,
        active
      }
      count (where:$where)
    }
  }
`;

export const seasonListInfo = async (variables?: SeasonListInfoQueryVariables) => {
    const response = await graph<SeasonListInfoQuery, SeasonListInfoQueryVariables>({
        query: seasonListInfoQuery,
        variables: variables
    });

    const seasons: {items: SeasonType[], count: number} = {
        items: [],
        count: 0
    };

    if(response.data?.seasons?.items?.length) {
        seasons.items = response.data!.seasons!.items!.map(c => {
            return {
                name: c!.name,
                active: c!.active,
                id: c!.id
            }
        });
        seasons.count = response.data.seasons.count || 0;
    }

    return {
        data: seasons,
        response: response
    }
}
// #endregion graph
